var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72716 12C1.259 12 0.854092 11.8439 0.512455 11.5318C0.170818 11.2197 0 10.8497 0 10.422V1.59538C0 1.16763 0.170818 0.794798 0.512455 0.476879C0.854092 0.15896 1.259 0 1.72716 0H6.69988L7.99051 1.17919H14.2539C14.722 1.17919 15.1301 1.33815 15.4781 1.65607C15.826 1.97399 16 2.34682 16 2.77457V10.422C16 10.8497 15.826 11.2197 15.4781 11.5318C15.1301 11.8439 14.722 12 14.2539 12H1.72716Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.b84ce1c1c9821d602eacc5ee155de242.svg";
export { ForwardRef as ReactComponent };